import { combineReducers } from "redux";
import studyabroadFormreducer from "../slices/studyabroad/index"
import medicalFormreducer from "../slices/medical/form";
import engineeringFormreducer from "../slices/engineering";
import idpFormreducer from "../slices/idp"
import schoolFormreducer from "../slices/school"
import userReducer from "../slices/user/index";
//schoolFormreducer
export default combineReducers({
  idpStydyabroad: studyabroadFormreducer,
  ipdMedical: medicalFormreducer,
  idpEngineering: engineeringFormreducer,
  idp: idpFormreducer,
  idpSchool: schoolFormreducer,
  userData: userReducer,
});
